import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  stores: [],
  recipients: [],
  selectedStore: null,
  loading: false,
  error: null,
  success: null,
};

export const EDNReducer = createSlice({
  name: "edn",
  initialState,
  reducers: {
    setStores: (state, action) => {
      state.stores = action.payload;
    },
    setRecipients: (state, action) => {
      state.recipients = action.payload;
    },
    setSelectedStore: (state, action) => {
      state.selectedStore = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setSuccess: (state, action) => {
      state.success = action.payload;
    },
    clearMessages: (state) => {
      state.error = null;
      state.success = null;
    },
  },
});

export const {
  setStores,
  setRecipients,
  setSelectedStore,
  setLoading,
  setError,
  setSuccess,
  clearMessages,
} = EDNReducer.actions;

export default EDNReducer.reducer;
